module.exports = __webpack_public_path__ + "static/media/LT3-BG3.6905f92f.jpg";